import {Component, OnInit} from '@angular/core';
import {GroupColumn} from '../../_models/OrdiniGroupColumns';
import {ModalController} from '@ionic/angular';
import {AccountOrganizzazione} from '../../_models/AccountOrganizzazione';
import {SaveMessage} from '../../_helpers/save-message';
import {OrganizzazioniService} from '../../_services/organizzazioni.service';

@Component({
    selector: 'app-ordini-group-columns',
    templateUrl: './ordini-group-columns.component.html',
    styleUrls: ['./ordini-group-columns.component.scss'],
    standalone: false
})
export class OrdiniGroupColumnsComponent implements OnInit {
  accountOrganizzazione: AccountOrganizzazione;
  loading = false;
  groupColumns: GroupColumn[] = [];

  constructor(
    private saveMessage: SaveMessage,
    private organizzazioneService: OrganizzazioniService,
    private modalCtrl: ModalController) { }

  ngOnInit() {
    this.groupColumns = this.organizzazioneService.groupColumns
      .sort((a, b) => a.order - b.order);
    const account = this.organizzazioneService.currentAccountSettingsSubject.value;
    this.accountOrganizzazione = account ? {...account} : null;
  }

  get hasSelectedColumns(): boolean {
    return this.groupColumns.some(column => column.active);
  }

  cancel = () => this.loading ? Promise.resolve(false) : this.modalCtrl.dismiss(false, 'cancel');

  handleReorder(ev: CustomEvent) {
    this.groupColumns = ev.detail.complete(this.groupColumns);
  }

  succesSave = async (): Promise<void> => {
    if (this.loading || !this.accountOrganizzazione) {
      return;
    }
    if (!this.hasSelectedColumns) {
      this.saveMessage.messageError('Seleziona almeno un criterio di raggruppamento.');
      return;
    }
    const groupColumns = this.groupColumns
      .filter(c => c.active)
      .map(c => c.columnName)
      .join(',');
    await this.saveConfiguration(groupColumns);
  };

  async resetDefault(): Promise<void> {
    if (this.loading || !this.accountOrganizzazione) {
      return;
    }
    await this.saveConfiguration(null);
  }

  private async saveConfiguration(groupColumns: string | null): Promise<void> {
    const account = {...this.accountOrganizzazione, groupColumns};
    const currentBeforeSave = this.organizzazioneService.currentAccountSettingsSubject.value;
    if (!currentBeforeSave || currentBeforeSave.organizzazioneId !== account.organizzazioneId || currentBeforeSave.accountId !== account.accountId) {
      this.saveMessage.messageError('L’azienda o l’account è cambiato. Chiudi e riapri la configurazione.');
      return;
    }
    this.loading = true;
    try {
      const saved: AccountOrganizzazione = await this.organizzazioneService.saveAccountOrganizzazioneAsync(account);
      const current = this.organizzazioneService.currentAccountSettingsSubject.value;
      if (current && current.organizzazioneId === account.organizzazioneId && current.accountId === account.accountId) {
        this.organizzazioneService.setCurrentAccountSettingsValue(saved);
      }
      await this.modalCtrl.dismiss(true, 'confirm');
    } catch {
      this.saveMessage.messageError('Ci sono problemi con il salvataggio.');
    } finally {
      this.loading = false;
    }
  }
}
